import { render } from "./resultTable.vue?vue&type=template&id=53ccf134&scoped=true"
import script from "./resultTable.vue?vue&type=script&lang=js"
export * from "./resultTable.vue?vue&type=script&lang=js"

import "./resultTable.vue?vue&type=style&index=0&id=53ccf134&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ccf134"]])

export default __exports__